define(["require", "exports", "tslib", "@arcgis/core/Map", "@arcgis/core/geometry/Extent", "@arcgis/core/geometry/Point", "@arcgis/core/geometry/Polygon", "@arcgis/core/geometry/Polyline", "@arcgis/core/geometry/coordinateFormatter", "@arcgis/core/layers/FeatureLayer", "@arcgis/core/layers/ImageryLayer", "@arcgis/core/layers/MapImageLayer", "@arcgis/core/layers/TileLayer", "@arcgis/core/layers/VectorTileLayer", "@arcgis/core/views/MapView", "@arcgis/core/widgets/ScaleBar", "@arcgis/core/widgets/TimeSlider", "lodash.throttle", "mobx-react", "moment", "react", "../model/services/EventManager", "../store", "../store/Events", "../store/StoreManager", "../utils/Environment", "../utils/SpatialReferenceFactory"], function (require, exports, tslib_1, Map_1, Extent_1, Point_1, Polygon_1, Polyline_1, coordinateFormatter, FeatureLayer_1, ImageryLayer_1, MapImageLayer_1, TileLayer_1, VectorTileLayer_1, MapView_1, ScaleBar_1, TimeSlider_1, lodash_throttle_1, mobx_react_1, moment_1, React, EventManager_1, store_1, Events_1, StoreManager_1, Environment_1, SpatialReferenceFactory_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MapView = exports.refreshMap = exports.enablePan = exports.disablePan = exports.goTo = void 0;
    Map_1 = tslib_1.__importDefault(Map_1);
    Extent_1 = tslib_1.__importDefault(Extent_1);
    Point_1 = tslib_1.__importDefault(Point_1);
    Polygon_1 = tslib_1.__importDefault(Polygon_1);
    Polyline_1 = tslib_1.__importDefault(Polyline_1);
    coordinateFormatter = tslib_1.__importStar(coordinateFormatter);
    FeatureLayer_1 = tslib_1.__importDefault(FeatureLayer_1);
    ImageryLayer_1 = tslib_1.__importDefault(ImageryLayer_1);
    MapImageLayer_1 = tslib_1.__importDefault(MapImageLayer_1);
    TileLayer_1 = tslib_1.__importDefault(TileLayer_1);
    VectorTileLayer_1 = tslib_1.__importDefault(VectorTileLayer_1);
    MapView_1 = tslib_1.__importDefault(MapView_1);
    ScaleBar_1 = tslib_1.__importDefault(ScaleBar_1);
    TimeSlider_1 = tslib_1.__importDefault(TimeSlider_1);
    lodash_throttle_1 = tslib_1.__importDefault(lodash_throttle_1);
    moment_1 = tslib_1.__importDefault(moment_1);
    React = tslib_1.__importStar(React);
    function goTo(map, target, zoom) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                yield map.goTo(target, { animate: false });
                if (zoom) {
                    map.zoom = zoom;
                }
                else if (target instanceof Polyline_1.default || target instanceof Polygon_1.default) {
                    yield map.goTo(target.extent.expand(1.2));
                }
            }
            catch (err) {
                console.error("Zoom failed", err);
            }
        });
    }
    exports.goTo = goTo;
    function disablePan(map) {
        map.navigation.gamepad.enabled = false;
        map.navigation.browserTouchPanEnabled = false;
        map.navigation.momentumEnabled = false;
        map.navigation.mouseWheelZoomEnabled = false;
    }
    exports.disablePan = disablePan;
    function enablePan(map) {
        map.navigation.gamepad.enabled = true;
        map.navigation.browserTouchPanEnabled = true;
        map.navigation.momentumEnabled = true;
        map.navigation.mouseWheelZoomEnabled = true;
    }
    exports.enablePan = enablePan;
    function refreshMap(map, layerId) {
        const layers = map.map.allLayers.toArray().filter(l => {
            if (layerId) {
                return l.id == layerId;
            }
            else {
                return true;
            }
        });
        for (let l of layers) {
            if (l.type == "map-image") {
                l === null || l === void 0 ? void 0 : l.refresh();
            }
        }
    }
    exports.refreshMap = refreshMap;
    const LS_MAP_EXTENT = `${(0, Environment_1.getEnvironment)()}_MapExtent`;
    let MapView = exports.MapView = class MapView extends React.Component {
        constructor(props) {
            super(props);
            Object.defineProperty(this, "map", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "mapNode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: React.createRef()
            });
            Object.defineProperty(this, "scaleNode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: React.createRef()
            });
            Object.defineProperty(this, "onClick", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (e) => {
                    const { routeStore, uiStore, searchStore } = this.props;
                    const canSearch = !routeStore.IsEntityRouteActive
                        && !routeStore.IsEntityCreateRouteActive
                        && !uiStore.IsRedlineToolActive;
                    if (canSearch) {
                        e.mapPoint && searchStore.searchByGeometry(e.mapPoint);
                    }
                    else if (!uiStore.IsRedlineToolActive) {
                        const screenPoint = { x: e.x, y: e.y };
                        this.map.hitTest(screenPoint).then(({ results }) => {
                            var _a;
                            EventManager_1.EventManager.Instance.emitAsync(Events_1.MAP_CLICK_EVENT, {
                                graphics: (_a = results === null || results === void 0 ? void 0 : results.filter(x => x.type === "graphic").map(x => x.graphic)) !== null && _a !== void 0 ? _a : [],
                                button: e.button
                            });
                        });
                    }
                }
            });
            Object.defineProperty(this, "onMapCoordinatesClick", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (e) => {
                    this.setState({
                        mouseCoordinatesInDecimalDegrees: !this.state.mouseCoordinatesInDecimalDegrees
                    });
                }
            });
            Object.defineProperty(this, "pointToString", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (p) => {
                    try {
                        if (!p || !p.y || !p.x || coordinateFormatter.isSupported() === false) {
                            return "N/A";
                        }
                        if (this.state.mouseCoordinatesInDecimalDegrees) {
                            return coordinateFormatter.toLatitudeLongitude(p, "dd", 5);
                        }
                        return coordinateFormatter.toLatitudeLongitude(p, "dms", 1);
                    }
                    catch (err) {
                        console.info({
                            p,
                            lat: p && p.y,
                            lng: p && p.x,
                            isSupported: coordinateFormatter.isSupported()
                        });
                        return "";
                    }
                }
            });
            Object.defineProperty(this, "onMouseMove", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (e) => {
                    this.setState({
                        mouseMapPoint: new Point_1.default(this.map.toMap({ x: e.x, y: e.y }))
                    });
                }
            });
            this.state = {
                mouseMapPoint: null,
                mouseCoordinatesInDecimalDegrees: true,
                scaleLevel: null
            };
        }
        mountTimeFilter() {
            const startTimeMin = new Date(2012, 6, 1);
            const endTimeMax = (0, moment_1.default)().add(5, "years").toDate();
            const initialStartTime = (0, moment_1.default)().add(-2, "years").toDate();
            const initialEndTime = (0, moment_1.default)().add(2, "years").toDate();
            new TimeSlider_1.default({
                view: this.props.mapStore.Map,
                mode: "time-window",
                fullTimeExtent: {
                    start: startTimeMin,
                    end: endTimeMax
                },
                timeExtent: {
                    start: initialStartTime,
                    end: initialEndTime
                },
                stops: {
                    interval: {
                        value: 1,
                        unit: "months"
                    }
                }
            });
            console.log("Mount time slider");
        }
        componentDidMount() {
            const config = this.props.configStore.WebConfig;
            const { map: mapConfig } = config;
            const map = new Map_1.default({});
            const resolveLayer = (l) => {
                var _a, _b, _c, _d, _e;
                let layer;
                let layerId = l.label;
                if (l.type == "tiled") {
                    const options = {
                        id: layerId,
                        opacity: l.alpha ? parseFloat(l.alpha.toString()) : 1,
                        visible: (_a = l.visible) !== null && _a !== void 0 ? _a : true,
                        url: l.url,
                        resampling: false
                    };
                    layer = new TileLayer_1.default(options);
                    layer.when(() => {
                        this.setState({
                            scaleLevel: this.map.scale
                        });
                    });
                    console.info("Adding tile layer to map", layer.url);
                }
                else if (l.type == "vectortiled") {
                    const options = {
                        id: layerId,
                        opacity: l.alpha ? parseFloat(l.alpha.toString()) : 1,
                        visible: (_b = l.visible) !== null && _b !== void 0 ? _b : true,
                        url: l.url
                    };
                    layer = new VectorTileLayer_1.default(options);
                    layer.when(() => {
                        this.setState({
                            scaleLevel: this.map.scale
                        });
                        if (layer instanceof VectorTileLayer_1.default) {
                            (0, store_1.prepareVectorLayerStyles)(`${layer.id}-light`, layer);
                        }
                    });
                    console.info("Adding vector tile layer to map", layer.url);
                }
                else if (l.type === "feature") {
                    const options = {
                        id: layerId,
                        opacity: l.alpha ? parseFloat(l.alpha.toString()) : 0,
                        visible: (_c = l.visible) !== null && _c !== void 0 ? _c : false,
                        url: l.url
                    };
                    if ((0, Environment_1.isLocal)() || (0, Environment_1.isDevelopment)()) {
                        options.opacity = 1;
                    }
                    layer = new FeatureLayer_1.default(options);
                    console.info("Adding feature layer to map", layer.url, options);
                }
                else if (l.type === "imagery") {
                    const options = {
                        id: layerId,
                        opacity: l.alpha ? parseFloat(l.alpha.toString()) : 1,
                        visible: (_d = l.visible) !== null && _d !== void 0 ? _d : true,
                        url: l.url
                    };
                    layer = new ImageryLayer_1.default(options);
                    console.info("Adding image layer to map", layer.url);
                }
                else {
                    const options = {
                        id: layerId,
                        opacity: l.alpha ? parseFloat(l.alpha.toString()) : 1,
                        visible: (_e = l.visible) !== null && _e !== void 0 ? _e : true,
                        url: l.url
                    };
                    layer = new MapImageLayer_1.default(options);
                    layer.when(() => {
                        if (layer instanceof MapImageLayer_1.default) {
                            if (l.excludedLayerIds && l.excludedLayerIds.length > 0) {
                                layer.allSublayers.forEach(x => {
                                    let enabled = x.visible && l.excludedLayerIds.indexOf(x.id) === -1;
                                    if (x.visible != enabled) {
                                        console.info("layer", x.id, x.title, "from", x.visible, "to", enabled);
                                        x.visible = enabled;
                                    }
                                });
                            }
                        }
                    });
                    console.info("Adding image layer to map", layer.url);
                }
                return layer;
            };
            mapConfig.layers.map(l => {
                map.layers.add(resolveLayer(l));
            });
            let extent = this.getCachedExtent();
            if (!extent) {
                const [xmin, ymin, xmax, ymax] = mapConfig.initialextent.map(x => parseFloat(x));
                extent = new Extent_1.default({
                    xmin,
                    xmax,
                    ymin,
                    ymax,
                    spatialReference: SpatialReferenceFactory_1.SpatialReferenceFactory.GDA_1994
                });
            }
            this.map = new MapView_1.default({
                map: map,
                spatialReference: SpatialReferenceFactory_1.SpatialReferenceFactory.GDA_1994,
                container: this.mapNode.current,
                extent,
                constraints: {
                    rotationEnabled: false
                }
            });
            this.map.when(() => {
                this.props.onMapLoaded(this.map);
                const scaleBar = new ScaleBar_1.default({
                    view: this.map,
                    container: this.scaleNode.current,
                    unit: "metric"
                });
                scaleBar.when((callback, err) => {
                    console.info("scalebar", { callback, err });
                });
                this.mountTimeFilter();
            });
            this.map.watch("scale", scale => {
                this.setState({
                    scaleLevel: scale
                });
            });
            this.map.watch("extent", (extent) => {
                extent && localStorage && localStorage.setItem(LS_MAP_EXTENT, JSON.stringify(extent.toJSON()));
            });
            this.map.on("click", this.onClick);
            this.map.on("pointer-move", (0, lodash_throttle_1.default)(this.onMouseMove, 250, { leading: false, trailing: true }));
            if (coordinateFormatter.isSupported()) {
                coordinateFormatter.load();
            }
        }
        getCachedExtent() {
            if (localStorage && localStorage.getItem(LS_MAP_EXTENT)) {
                const cached = localStorage.getItem(LS_MAP_EXTENT);
                try {
                    return new Extent_1.default(JSON.parse(cached));
                }
                catch (err) {
                    console.error("Unable to parse cached extent");
                }
            }
            return null;
        }
        render() {
            const { uiStore } = this.props;
            const { mouseMapPoint, scaleLevel } = this.state;
            return React.createElement("div", { className: "mapContainer " + (!uiStore.IsDesktop && uiStore.IsMapOpen ? "mapContainerVisible" : "") },
                React.createElement("div", { ref: this.scaleNode, className: "scale" }),
                React.createElement("ul", { className: "status-info" },
                    React.createElement("li", { className: "map-coordinates", onClick: this.onMapCoordinatesClick }, !!mouseMapPoint ? this.pointToString(mouseMapPoint) : ""),
                    React.createElement("li", { className: "scale-level" }, !!scaleLevel ? "1:" + scaleLevel.toLocaleString() : "")),
                React.createElement("div", { ref: this.mapNode, className: "map" }));
        }
    };
    exports.MapView = MapView = tslib_1.__decorate([
        (0, mobx_react_1.inject)(context => (0, StoreManager_1.injectStores)(context)),
        mobx_react_1.observer
    ], MapView);
    exports.default = MapView;
});
